export default "__VITE_ASSET__BO36dGPG__"